const config = {
  apiUrl: 'https://api.rateduct.com/',
  callbackUrlBase: 'https://logirate.rateduct.com/',
};

export default config;
